module.exports = __webpack_public_path__ + "media/application/images/2023/04_still-1250x703-7fd874c8279808c7bec86f19e698969b.png";